<template>
    <div>
        <!-- 上传委托 -->
    </div>
</template>

<script>
export default {}
</script>

<style>
</style>